import React, { Component } from 'react';
import DialogInput from 'screens/components/advanced/DialogInput';
import "styles/sass/support/VideoSupportPage.scss";
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';

class VideoBodyComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openVideo: false,
      currentVideoUrl: "",
      currentVideoTitle: ""
    };
  }

  convertToEmbedUrl = (url) => {
    if (url.includes('watch?v=')) {
      return url.replace('watch?v=', 'embed/');
    } else if (url.includes('youtu.be/')) {
      return url.replace('youtu.be/', 'www.youtube.com/embed/');
    } else {
      return url;
    }
  };

  handleOpenVideo = (video) => {
    const embedUrl = this.convertToEmbedUrl(video.videoUrl);
    this.setState({ openVideo: true, currentVideoUrl: embedUrl, currentVideoTitle: video.title });
  };

  handleCloseVideo = () => {
    this.setState({ openVideo: false, currentVideoUrl: "" });
  };

  render() {
    const { videos } = this.props;
    const { openVideo, currentVideoUrl, currentVideoTitle } = this.state;
    return (
      <div className="video-container">
        {videos.map((video, i) => (
          <div
            key={i}
            className="video-card"
            onClick={() => this.handleOpenVideo(video)}
          >
            <img
              src={video.thumbnailUrl}
              alt={video.title}
              className="video-thumbnail"
            />
            <div className="video-info">
              <h2 className="video-title">
                {video.title}
              </h2>
              <p className="video-description">
                {video.description}
              </p>
            </div>
          </div>
        ))}
        <DialogInput
          modal={false}
          open={openVideo}
          onRequestClose={this.handleCloseVideo}
          contentStyle={{ width: "65vw", maxWidth: "none", overflowX: "hidden" }}
          title={<DialogHeaderWithClose text={`Video Support: ${currentVideoTitle}`} classicClass="posDialogClassic" handleClose={this.handleCloseVideo} />}
        >
          <div className="video">
            <iframe
              src={currentVideoUrl}
              allow="autoplay; encrypted-media"
              allowFullScreen
          />
          </div>
        </DialogInput>
      </div>
    );
  }
}

export default VideoBodyComponent;
